<script lang="ts">
	interface Props {
		className?: string;
		stroke?: number;
		hexColor?: string;
	}

	let { className = '', stroke = 1, hexColor = '' }: Props = $props();
</script>

<div class={className}>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		stroke="currentColor"
		color={hexColor}
		fill="none"
		stroke-width={stroke}
	>
		<line x1="12" y1="2" x2="12" y2="22" stroke-linecap="round" />
		<line x1="2" y1="12" x2="22" y2="12" stroke-linecap="round" />
	</svg>
</div>
